import { Alert, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import type { AvtaleDto } from "@/api/generated";

export const UgyldigAvtaleSection = ({ avtale }: { avtale: AvtaleDto }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Alert data-color="warning">
        <Paragraph>
          {t("pages.avtaler.avtaler.ugyldig-avtale.beskrivelse")}
        </Paragraph>
        <Paragraph>
          {t("pages.avtaler.avtaler.ugyldig-avtale.årsak", {
            context: t("pages.avtaler.statuser.ugyldigAvtaleÅrsak", {
              context: avtale.ugyldigAvtaleÅrsak ?? "",
            }),
          })}
        </Paragraph>
        <br />
        {avtale.ugyldigAvtaleMeldingTilEier != null ? (
          <div>
            <Paragraph>
              {t(
                "pages.avtaler.avtaler.ugyldig-avtale.melding-fra-leverandør",
                {
                  context: avtale.leverandør.name ?? "",
                },
              )}
            </Paragraph>
            <Paragraph className="italic">
              {avtale.ugyldigAvtaleMeldingTilEier}
            </Paragraph>
          </div>
        ) : (
          <Paragraph>
            {t("pages.avtaler.avtaler.ugyldig-avtale.default-melding", {
              context: avtale.leverandør.name ?? "",
            })}
          </Paragraph>
        )}
      </Alert>
    </div>
  );
};
